import script from "./RestrictedAccessMark.vue?vue&type=script&setup=true&lang=js"
export * from "./RestrictedAccessMark.vue?vue&type=script&setup=true&lang=js"

import "./RestrictedAccessMark.vue?vue&type=style&index=0&id=24b0f392&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b0f392"]])

export default __exports__